import ReportsPanel from '../../../components/ReportsPanel';
import { useBotWorkspace } from '../../../hooks/useBotWorkspace';

export default function ReportsRoute() {
  const { bot } = useBotWorkspace();
  if (!bot) return null;
  return <ReportsPanel bot={bot} />;
}
